// extracted by mini-css-extract-plugin
export default {"allCoursesPageWrapper":"allCoursePageStyles_allCoursesPageWrapper__e8utK"};